import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface Testimonial {
  role: string;
  quote: string;
  name: string;
  title: string;
  company: string;
  companyLogo: string;
}
const testimonials: Testimonial[] = [{
  role: 'SALES LEADERS',
  quote: 'OpenMart has become the backbone of our outreach strategy. Having direct access to the right contacts and see their social media pages has significantly boosted our ability to connect with restaurants and demonstrate the value we offer.',
  name: 'Evan Cucuk',
  title: 'VP of Sales',
  company: 'Boostly',
  companyLogo: 'https://cdn.magicpatterns.com/uploads/bGkTb57QoPFftaz7pP4DiC/Boostly_Logo_Logo.jpg'
}, {
  role: 'HEALTHCARE',
  quote: 'Having direct access to accurate contact information for facility administrators and directors has significantly boosted our ability to connect with healthcare facilities and demonstrate the value we offer!',
  name: 'Calvin Bulzoni',
  title: '',
  company: 'Clipboard Health',
  companyLogo: 'https://cdn.magicpatterns.com/uploads/tMZrW8AKEwLuGCToxJJH6e/63d7e4dcc375a62efe51e399_bunnylogo.png'
}, {
  role: 'TOP OF FUNNEL',
  quote: "Openmart automates the most difficult part of the sales team's top of funnel process: finding good quality leads for the sales reps to contact.",
  name: 'Marten',
  title: '',
  company: 'Whatnot',
  companyLogo: 'https://cdn.magicpatterns.com/uploads/tmqnQZJLsrAH2FJMnZtSb9/Whatnot_Logo_2025.svg.png'
}, {
  role: 'SMB',
  quote: 'Openmart provides quality leads and support at a price that small and medium businesses can afford. Their scraping methodology allows you to find "hidden gems" of data that other providers may not source for you.',
  name: 'Bryan Tidd',
  title: '',
  company: 'Eligo Energy',
  companyLogo: 'https://cdn.magicpatterns.com/uploads/av31QTTy6UnGBjyz6Gp4M8/eligo-logo-c5bdec60436590dba76744de7d4e17ef359e49733cb5b99fec42e4b81799d4f3.png'
}];
const companies = [{
  name: 'DoorDash',
  logo: 'https://cdn.magicpatterns.com/uploads/anfjnKVP269cYHU5qxQS2k/DoorDash_Logo.svg.png'
}, {
  name: 'Whatnot',
  logo: 'https://cdn.magicpatterns.com/uploads/tmqnQZJLsrAH2FJMnZtSb9/Whatnot_Logo_2025.svg.png'
}, {
  name: 'Clay',
  logo: 'https://cdn.magicpatterns.com/uploads/jBmrAaM5BuFQEM4ihdQqDJ/Clay-Logo-Light-1024x548.png'
}, {
  name: 'JLL',
  logo: 'https://cdn.magicpatterns.com/uploads/o1aBNzghZtL5UC7oFNV1HZ/JLL_logo.svg-2.png'
}, {
  name: 'Alibaba',
  logo: 'https://cdn.magicpatterns.com/uploads/hxfPEtMS8Xy75fyirjy1B4/Alibaba.com-logo-1.png'
}];
export function Testimonials() {
  const [hoveredIdx, setHoveredIdx] = useState<number | null>(null);
  const tickerItems = [...companies, ...companies, ...companies];
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3559">
      <div className="bg-white rounded-[2.5rem] shadow-sm border border-slate-100 overflow-hidden" data-id="element-3560">
        {/* Company Logo Ticker — integrated at top */}
        <div className="relative py-8 border-b border-slate-100 overflow-hidden" data-id="element-3561">
          <p className="text-center text-sm font-bold text-slate-400 uppercase tracking-wider mb-5" data-id="element-3562">
            Trusted by leading companies
          </p>

          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-3563" />
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-3564" />

          <div className="flex w-max animate-ticker" data-id="element-3565">
            {tickerItems.map((company, index) => <div key={index} className="flex items-center justify-center px-14" data-id="element-3566">
                <img src={company.logo} alt={`${company.name} logo`} className="h-8 max-w-[160px] object-contain opacity-50 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-300" data-id="element-3567" />
              </div>)}
          </div>
        </div>

        {/* Testimonials Content */}
        <div className="p-8 md:p-16" data-id="element-3568">
          {/* Header */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5
        }} className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16" data-id="element-3569">
            <div className="max-w-xl" data-id="element-3570">
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-3571">
                The <span className="text-blue-600" data-id="element-3572">fastest growing</span> teams
                use Openmart
              </h2>
              <p className="text-lg text-slate-500" data-id="element-3573">
                Over 10,000 companies use Openmart to reach local businesses and
                stay ahead.
              </p>
            </div>
            <motion.div initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="flex items-center gap-4" data-id="element-3574">
              <div className="flex -space-x-4" data-id="element-3575">
                {['https://images.unsplash.com/photo-1560250097-0b93528c311a?w=100&h=100&fit=crop&crop=face', 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=100&h=100&fit=crop&crop=face', 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face', 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=100&h=100&fit=crop&crop=face'].map((img, i) => <motion.img key={i} animate={{
                y: [0, -8, 0]
              }} transition={{
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut',
                delay: i * 0.3
              }} src={img} alt="User" className="w-12 h-12 rounded-full border-2 border-white shadow-sm" data-id="element-3576" />)}
              </div>
              <div className="text-sm font-bold text-slate-900" data-id="element-3577">
                Join 10k+ users
              </div>
            </motion.div>
          </motion.div>

          {/* Grid */}
          <div className="grid md:grid-cols-2 gap-6 relative" data-id="element-3578">
            {testimonials.map((testimonial, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: idx * 0.08
          }} onMouseEnter={() => setHoveredIdx(idx)} onMouseLeave={() => setHoveredIdx(null)} className="bg-white rounded-3xl p-8 md:p-10 border border-slate-200 hover:border-blue-200 hover:shadow-2xl hover:shadow-blue-600/10 hover:-translate-y-2 transition-all duration-300 relative group overflow-hidden" data-id="element-3579">
                <div className="absolute inset-0 bg-blue-50/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" data-id="element-3580"></div>

                <div className="relative z-10 flex flex-col h-full" data-id="element-3581">
                  <div className="text-xs font-bold text-blue-600 tracking-wider uppercase mb-6" data-id="element-3582">
                    {testimonial.role}
                  </div>

                  <p className="text-xl text-slate-700 leading-relaxed mb-10 flex-grow font-medium" data-id="element-3583">
                    "{testimonial.quote}"
                  </p>

                  <div className="flex items-center justify-between pt-6 border-t border-slate-100" data-id="element-3584">
                    <div data-id="element-3585">
                      <div className="font-bold text-slate-900" data-id="element-3586">
                        {testimonial.name}
                      </div>
                      <div className="text-sm text-slate-500" data-id="element-3587">
                        {testimonial.title ? `${testimonial.title}, ${testimonial.company}` : testimonial.company}
                      </div>
                    </div>

                    <div className="w-24 h-8 relative" data-id="element-3588">
                      <AnimatePresence mode="wait" data-id="element-3589">
                        {hoveredIdx === idx ? <motion.img key="logo" initial={{
                      opacity: 0,
                      scale: 0.8
                    }} animate={{
                      opacity: 1,
                      scale: 1
                    }} exit={{
                      opacity: 0,
                      scale: 0.8
                    }} transition={{
                      duration: 0.2
                    }} src={testimonial.companyLogo} alt={testimonial.company} className="absolute inset-0 w-full h-full object-contain object-right" data-id="element-3590" /> : <motion.div key="initials" initial={{
                      opacity: 0,
                      scale: 0.8
                    }} animate={{
                      opacity: 1,
                      scale: 1
                    }} exit={{
                      opacity: 0,
                      scale: 0.8
                    }} transition={{
                      duration: 0.2
                    }} className="absolute inset-0 flex items-center justify-end" data-id="element-3591">
                            <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center text-slate-600 font-bold text-sm border border-slate-200" data-id="element-3592">
                              {testimonial.name.split(' ').map(n => n[0]).join('')}
                            </div>
                          </motion.div>}
                      </AnimatePresence>
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}